module.exports = __webpack_public_path__ + "img/norm-1.29aa54c.png";